import { apiClient } from './api-client';
import { UploadedFile } from '@/types/index';

export const fileService = {
  async uploadFile(propertyId: string, file: File) {
    const formData = new FormData();
    formData.append('file', file);

    // Utiliser axios directement pour les fichiers
    const response = await fetch(
      `${import.meta.env.VITE_API_URL || '/api'}/files/upload/${propertyId}`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: formData,
      }
    );

    if (!response.ok) {
      throw new Error('File upload failed');
    }

    const data = await response.json();
    return data.data as UploadedFile;
  },

  async listPropertyFiles(propertyId: string) {
    return apiClient.get<UploadedFile[]>(`/files/property/${propertyId}`);
  },

  async deleteFile(fileId: string) {
    return apiClient.delete<{ message: string }>(`/files/${fileId}`);
  },

  async setPrimaryPhoto(fileId: string) {
    return apiClient.patch<UploadedFile>(`/files/${fileId}/set-primary`);
  },

  async downloadFile(filename: string) {
    const url = `${import.meta.env.VITE_API_URL || '/api'}/files/${filename}`;
    const link = document.createElement('a');
    link.href = url;
    link.click();
  },
};
